// Bootstrap 'md' breakpoint: screens narrower than 768px are considered small
const SMALL_SCREEN_QUERY = '(max-width: 767.98px)';

const useIsSmallScreen = () =>
	typeof window !== 'undefined' &&
	typeof window.matchMedia === 'function' &&
	window.matchMedia(SMALL_SCREEN_QUERY).matches;

export default useIsSmallScreen;
